import { Link } from 'react-router-dom';
import { Home, Briefcase, ShieldCheck, Clock, TrendingUp } from 'lucide-react';

export function GatePage() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-navy-dark via-navy to-navy-light" dir="rtl">
      {/* Header */}
      <header className="container mx-auto px-6 py-8">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-lg bg-teal flex items-center justify-center">
            <span className="text-white font-bold text-xl">F</span>
          </div>
          <h1 className="text-2xl font-semibold text-white">FAI360</h1>
        </div>
      </header>

      {/* Hero */}
      <section className="container mx-auto px-6 pt-12 pb-16 text-center">
        <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
          אינטליגנציה פיננסית אחת — שני עולמות
        </h2>
        <p className="text-lg text-slate-300 max-w-2xl mx-auto">
          בחר את המודול המתאים לך: משכנתאות ללווים פרטיים או אשראי עסקי ליועצים פיננסיים.
        </p>
      </section>

      {/* Choice Cards */}
      <section className="container mx-auto px-6 pb-20">
        <div className="grid md:grid-cols-2 gap-6 max-w-5xl mx-auto">
          {/* Mortgage Card */}
          <Link
            to="/mortgage"
            className="group bg-white rounded-2xl p-8 hover:shadow-2xl transition-all duration-200 hover:-translate-y-1"
          >
            <div className="flex items-start gap-4 mb-6">
              <div className="w-14 h-14 rounded-xl bg-teal/10 flex items-center justify-center">
                <Home className="w-7 h-7 text-teal" />
              </div>
              <div>
                <div className="text-sm text-slate-500 font-medium">מודול ראשון</div>
                <h3 className="text-2xl font-bold text-navy">משכנתאות</h3>
              </div>
            </div>
            <p className="text-slate-600 mb-6">
              פלטפורמת אופטימיזציה של משכנתאות ללווים פרטיים. ניתוח תמהיל אישי, השוואת בנקים, מדד הפחד.
            </p>
            <ul className="space-y-2 text-sm text-slate-700 mb-6">
              <li className="flex items-center gap-2">
                <span className="w-1.5 h-1.5 rounded-full bg-teal" />
                8 פרופילי לווה מותאמים
              </li>
              <li className="flex items-center gap-2">
                <span className="w-1.5 h-1.5 rounded-full bg-teal" />
                ריביות בנק ישראל בזמן אמת
              </li>
            </ul>
            <div className="text-teal font-semibold group-hover:translate-x-[-4px] transition">
              כניסה ללווה פרטי ←
            </div>
          </Link>

          {/* Business Card */}
          <Link
            to="/business"
            className="group bg-white rounded-2xl p-8 hover:shadow-2xl transition-all duration-200 hover:-translate-y-1 relative overflow-hidden"
          >
            <div className="absolute top-4 left-4 bg-business-accent/10 text-business-accent text-xs font-semibold px-2 py-1 rounded">
              חדש
            </div>
            <div className="flex items-start gap-4 mb-6">
              <div className="w-14 h-14 rounded-xl bg-business-primary/10 flex items-center justify-center">
                <Briefcase className="w-7 h-7 text-business-primary" />
              </div>
              <div>
                <div className="text-sm text-slate-500 font-medium">מודול שני</div>
                <h3 className="text-2xl font-bold text-navy">אשראי עסקי</h3>
              </div>
            </div>
            <p className="text-slate-600 mb-6">
              כלי Back-Office ליועצים פיננסיים לגיוס מימון עסקי מבנקים וגופים חוץ-בנקאיים. החלפה של אקסל בכלי מדוייק ומבוסס.
            </p>
            <ul className="space-y-2 text-sm text-slate-700 mb-6">
              <li className="flex items-center gap-2">
                <span className="w-1.5 h-1.5 rounded-full bg-business-primary" />
                DSCR דינמי לאורך 25 שנים
              </li>
              <li className="flex items-center gap-2">
                <span className="w-1.5 h-1.5 rounded-full bg-business-primary" />
                9 סוגי הלוואה (שפיצר, בלון, גרייס, מתגלגלת)
              </li>
              <li className="flex items-center gap-2">
                <span className="w-1.5 h-1.5 rounded-full bg-business-primary" />
                השוואת הצעות בנק + ניתוח APR אמיתי
              </li>
            </ul>
            <div className="text-business-primary font-semibold group-hover:translate-x-[-4px] transition">
              כניסה ליועץ פיננסי ←
            </div>
          </Link>
        </div>

        {/* Trust indicators */}
        <div className="mt-16 flex flex-wrap justify-center gap-8 text-white/70 text-sm">
          <div className="flex items-center gap-2">
            <ShieldCheck className="w-5 h-5" />
            <span>אבטחה ברמה בנקאית</span>
          </div>
          <div className="flex items-center gap-2">
            <Clock className="w-5 h-5" />
            <span>RLS על כל הנתונים</span>
          </div>
          <div className="flex items-center gap-2">
            <TrendingUp className="w-5 h-5" />
            <span>בנוי בישראל</span>
          </div>
        </div>
      </section>
    </div>
  );
}
